import Service from "./Service"

class CalendarNoteService extends Service {

    findById = (id) => this.get(`/calendar-notes/${id}`)

    searchWithinMonth = (queryParams) => this.getWithParams("/calendar-notes", queryParams)

    searchForGivenDay = (queryParams) => this.getWithParams("/calendar-notes/day", queryParams)

    create = (request) => this.post("/calendar-notes", request)

    update = (id, request) => this.patch(`/calendar-notes/${id}`, request)

    delete = (id) => this.del(`/calendar-notes/${id}`)
}

const calendarNoteService = new CalendarNoteService()
export default calendarNoteService